/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "გუშინ",
        "-2": "გუშინწინ",
        "0": "დღეს",
        "1": "ხვალ",
        "2": "ზეგ",
        "future": {
          "one": "{0} დღეში",
          "other": "{0} დღეში"
        },
        "past": {
          "one": "{0} დღის წინ",
          "other": "{0} დღის წინ"
        }
      },
      "day-narrow": {
        "-1": "გუშინ",
        "-2": "გუშინწინ",
        "0": "დღეს",
        "1": "ხვალ",
        "2": "ზეგ",
        "future": {
          "one": "{0} დღეში",
          "other": "{0} დღეში"
        },
        "past": {
          "one": "{0} დღის წინ",
          "other": "{0} დღის წინ"
        }
      },
      "day-short": {
        "-1": "გუშინ",
        "-2": "გუშინწინ",
        "0": "დღეს",
        "1": "ხვალ",
        "2": "ზეგ",
        "future": {
          "one": "{0} დღეში",
          "other": "{0} დღეში"
        },
        "past": {
          "one": "{0} დღის წინ",
          "other": "{0} დღის წინ"
        }
      },
      "hour": {
        "0": "ამ საათში",
        "future": {
          "one": "{0} საათში",
          "other": "{0} საათში"
        },
        "past": {
          "one": "{0} საათის წინ",
          "other": "{0} საათის წინ"
        }
      },
      "hour-narrow": {
        "0": "ამ საათში",
        "future": {
          "one": "{0} საათში",
          "other": "{0} საათში"
        },
        "past": {
          "one": "{0} სთ წინ",
          "other": "{0} სთ წინ"
        }
      },
      "hour-short": {
        "0": "ამ საათში",
        "future": {
          "one": "{0} საათში",
          "other": "{0} საათში"
        },
        "past": {
          "one": "{0} სთ წინ",
          "other": "{0} სთ წინ"
        }
      },
      "minute": {
        "0": "ამ წუთში",
        "future": {
          "one": "{0} წუთში",
          "other": "{0} წუთში"
        },
        "past": {
          "one": "{0} წუთის წინ",
          "other": "{0} წუთის წინ"
        }
      },
      "minute-narrow": {
        "0": "ამ წუთში",
        "future": {
          "one": "{0} წუთში",
          "other": "{0} წუთში"
        },
        "past": {
          "one": "{0} წთ წინ",
          "other": "{0} წთ წინ"
        }
      },
      "minute-short": {
        "0": "ამ წუთში",
        "future": {
          "one": "{0} წუთში",
          "other": "{0} წუთში"
        },
        "past": {
          "one": "{0} წთ წინ",
          "other": "{0} წთ წინ"
        }
      },
      "month": {
        "-1": "გასულ თვეს",
        "0": "ამ თვეში",
        "1": "მომავალ თვეს",
        "future": {
          "one": "{0} თვეში",
          "other": "{0} თვეში"
        },
        "past": {
          "one": "{0} თვის წინ",
          "other": "{0} თვის წინ"
        }
      },
      "month-narrow": {
        "-1": "გასულ თვეს",
        "0": "ამ თვეში",
        "1": "მომავალ თვეს",
        "future": {
          "one": "{0} თვეში",
          "other": "{0} თვეში"
        },
        "past": {
          "one": "{0} თვის წინ",
          "other": "{0} თვის წინ"
        }
      },
      "month-short": {
        "-1": "გასულ თვეს",
        "0": "ამ თვეში",
        "1": "მომავალ თვეს",
        "future": {
          "one": "{0} თვეში",
          "other": "{0} თვეში"
        },
        "past": {
          "one": "{0} თვის წინ",
          "other": "{0} თვის წინ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "გასულ კვარტალში",
        "0": "ამ კვარტალში",
        "1": "შემდეგ კვარტალში",
        "future": {
          "one": "{0} კვარტალში",
          "other": "{0} კვარტალში"
        },
        "past": {
          "one": "{0} კვარტალის წინ",
          "other": "{0} კვარტალის წინ"
        }
      },
      "quarter-narrow": {
        "-1": "გასულ კვარტალში",
        "0": "ამ კვარტალში",
        "1": "შემდეგ კვარტალში",
        "future": {
          "one": "{0} კვარტალში",
          "other": "{0} კვარტალში"
        },
        "past": {
          "one": "{0} კვარტ. წინ",
          "other": "{0} კვარტ. წინ"
        }
      },
      "quarter-short": {
        "-1": "გასულ კვარტალში",
        "0": "ამ კვარტალში",
        "1": "შემდეგ კვარტალში",
        "future": {
          "one": "{0} კვარტალში",
          "other": "{0} კვარტალში"
        },
        "past": {
          "one": "{0} კვარტ. წინ",
          "other": "{0} კვარტ. წინ"
        }
      },
      "second": {
        "0": "ახლა",
        "future": {
          "one": "{0} წამში",
          "other": "{0} წამში"
        },
        "past": {
          "one": "{0} წამის წინ",
          "other": "{0} წამის წინ"
        }
      },
      "second-narrow": {
        "0": "ახლა",
        "future": {
          "one": "{0} წამში",
          "other": "{0} წამში"
        },
        "past": {
          "one": "{0} წმ წინ",
          "other": "{0} წმ წინ"
        }
      },
      "second-short": {
        "0": "ახლა",
        "future": {
          "one": "{0} წამში",
          "other": "{0} წამში"
        },
        "past": {
          "one": "{0} წმ წინ",
          "other": "{0} წმ წინ"
        }
      },
      "week": {
        "-1": "გასულ კვირაში",
        "0": "ამ კვირაში",
        "1": "მომავალ კვირაში",
        "future": {
          "one": "{0} კვირაში",
          "other": "{0} კვირაში"
        },
        "past": {
          "one": "{0} კვირის წინ",
          "other": "{0} კვირის წინ"
        }
      },
      "week-narrow": {
        "-1": "გასულ კვირაში",
        "0": "ამ კვირაში",
        "1": "მომავალ კვირაში",
        "future": {
          "one": "{0} კვირაში",
          "other": "{0} კვირაში"
        },
        "past": {
          "one": "{0} კვირის წინ",
          "other": "{0} კვირის წინ"
        }
      },
      "week-short": {
        "-1": "გასულ კვირაში",
        "0": "ამ კვირაში",
        "1": "მომავალ კვირაში",
        "future": {
          "one": "{0} კვირაში",
          "other": "{0} კვირაში"
        },
        "past": {
          "one": "{0} კვ. წინ",
          "other": "{0} კვ. წინ"
        }
      },
      "year": {
        "-1": "გასულ წელს",
        "0": "ამ წელს",
        "1": "მომავალ წელს",
        "future": {
          "one": "{0} წელიწადში",
          "other": "{0} წელიწადში"
        },
        "past": {
          "one": "{0} წლის წინ",
          "other": "{0} წლის წინ"
        }
      },
      "year-narrow": {
        "-1": "გასულ წელს",
        "0": "ამ წელს",
        "1": "მომავალ წელს",
        "future": {
          "one": "{0} წელში",
          "other": "{0} წელში"
        },
        "past": {
          "one": "{0} წლის წინ",
          "other": "{0} წლის წინ"
        }
      },
      "year-short": {
        "-1": "გასულ წელს",
        "0": "ამ წელს",
        "1": "მომავალ წელს",
        "future": {
          "one": "{0} წელში",
          "other": "{0} წელში"
        },
        "past": {
          "one": "{0} წლის წინ",
          "other": "{0} წლის წინ"
        }
      }
    },
    "locale": "ka"
  });
}